import type { PasskeyCallbackReason } from '@modules/passkey/interfaces/passkey-callback.interface';

const passkeyErrorCodeMap: Record<number, PasskeyCallbackReason> = {
  130200: 'passkeyNotConfigured',
  130201: 'challengeExpired',
  130202: 'verifyFailed',
  130203: 'credentialNotFound',
  130204: 'duplicateCredential',
  130205: 'verifyFailed',
  130206: 'credentialNotFound',
  130207: 'verifyFailed',
  130208: 'verifyFailed',
  130209: 'verifyFailed',
  130210: 'verifyFailed',
  130211: 'passkeyLoginNotEnabled',
};

export const mapPasskeyBeErrorCode = (code: number): PasskeyCallbackReason | undefined => passkeyErrorCodeMap[code];

export const mapPasskeyBeErrorCodeOrUnknown = (code: number): PasskeyCallbackReason =>
  mapPasskeyBeErrorCode(code) ?? 'unknown';
